import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { questions } from '../data/faq';
export function FAQ() {
  const [open, setOpen] = useState(0);
  return <section className="bg-cream-100 py-20" aria-labelledby="faq-title" data-id="element-65" data-mp="1he2wzy8t5mf4">
      <div className="mx-auto max-w-3xl px-4" data-id="element-66" data-mp="1cfjd03drykpe">
        <h2 id="faq-title" className="text-balance text-center text-3xl font-extrabold text-forest-950 md:text-4xl" data-id="element-67" data-mp="1ccndiama3nyu">
          Preguntas frecuentes
        </h2>

        <div className="mt-10 space-y-3" data-id="element-68" data-mp="254gsxzuik5ez">
          {questions.map(([question, answer], index) => {
          const isOpen = index === open;
          return <article key={question} className={`overflow-hidden rounded-lg border bg-white transition-colors duration-200 ease-out ${isOpen ? 'border-forest-700' : 'border-earth-200'}`} data-id="element-69" data-mp="1v5hkoidnubsi" data-mpi={index}>
                <h3 data-id="element-70" data-mp="jo9fhuv6wrna">
                  <button type="button" className="flex w-full items-center justify-between gap-5 px-5 py-5 text-left font-sans font-bold text-forest-950 focus:outline-none focus-visible:ring-4 focus-visible:ring-gold-300/60 sm:px-6" onClick={() => setOpen(isOpen ? -1 : index)} aria-expanded={isOpen} data-id="element-71" data-mp="jrxbr1s0rs5p">
                    <span data-id="element-72" data-mp="1fqq94x4wtx6k">{question}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-earth-500 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-73" data-mp="11wz0dqz06hbw" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-74" data-mp="wxmfhbrozkby">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-75" data-mp="iycxc6jxeg5c">
                      <p className="border-t border-earth-100 px-5 py-4 leading-relaxed text-earth-800 sm:px-6" data-id="element-76" data-mp="2kw6p25ta5yam">{answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </article>;
        })}
        </div>
      </div>
    </section>;
}